// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__2nCAF","Container":"Footer_Container__3WIq5"};